import {actions as A} from '../constants/actions';

const defaultState = {
  list: null,
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_STEP_11_FILE_LIST:
      return {...state, loading: true, error: false, errorMessage: null, list: null,};

    case A.GET_STEP_11_FILE_LIST_SUCCESS:
      const {list} = payload;
      return {...state, loading: false, error: false, errorMessage: null, list};

    case A.GET_STEP_11_FILE_LIST_FAILURE:
      const {errorMessage} = payload;
      return {...state, loading: false, error: true, errorMessage};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

